import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { routes } from './routes';
import ErrorBoundary from './components/errorBoundary/ErrorBoundary';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Personaliza from './components/ferramentas/Personaliza';

const App = () => {
  return (
    
    <ErrorBoundary>
      <div>
        <ToastContainer/>
      </div>
      <div className='container' id='container'>
        <Router>
          <Personaliza />
          <Routes>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.element}
              >
                {route.children && route.children.map((childRoute, childIndex) => (
                  <Route
                    key={childIndex}
                    path={childRoute.path}
                    index={childRoute.index}
                    element={childRoute.element}
                  />
                ))}
              </Route>
            ))}
          </Routes>
        </Router>
      </div>
    </ErrorBoundary>
  );
};

export default App;